<template>
  <div id="header">
    <!-- <div :class="headerFix ? 'header_fix' : 'header_fix active'">
      <router-link class="logo" to="/" target="_blank">
        <img src="../assets/images/logo00.png" />
      </router-link>
      <div class="search">
        <input class="search_left" type="text" placeholder="搜索 商品" v-model="keytitle" />
        <div class="search_right" @click="onSearch(keytitle)">搜索</div>
      </div>
      <div class="car" @click="goCar">
        <i></i>
      </div>
    </div> -->
    <div class="container header_top">
      <div class="container">
        <!-- <a href="javascript:void(0)">个人中心</a> -->
        <a href="javascript:void(0)" @click="loginToast" v-if="phone == ''" class="before">登录/注册</a>
        <dl v-if="phone != ''">
          <!-- <dt @click="onUser"> -->
          <dt>
            {{phone}}
            <i></i>
          </dt>
          <dd>
            <i></i>
            <img :src="icon" />
            <p>{{nick}}</p>
            <a href="javascript:void(0)" @click="signOut" class="before">退出登录</a>
          </dd>
        </dl>
        <!-- <a href="javascript:void(0)" @click="goOrder">我的订单</a>
        <a href="javascript:void(0)" @click="goCar">购物车</a>
        <a href="javascript:void(0)">联系客服</a> -->
        <!-- <a href="javascript:void(0)" class="right">我的收藏</a> -->
        <!-- <a href="javascript:void(0)" class="right before" @click="customer">联系客服</a> -->
      </div>
    </div>
    <div class="container header_bottom">
      <router-link class="logo" to="/" target="_self">
        <img src="../assets/images/logo00.png" />
      </router-link>
      <div class="txt1" @click="toMqjp">
        精企精品
      </div>
      <!-- <div class="txt2" @click="toGsjp">
        各省精品
      </div> -->
    
      <!-- <ul class="qr_code">
        <button class="btn_1" @click="goCar">
          <i class="el-icon-my-export"></i>
          购物车
        </button>
        <button class="btn_2" @click="goOrder">我的订单</button>
      </ul> -->
      <!-- <div class="search"> -->
        <div class="search_box">
          <input
            class="search_left"
            type="text"
            placeholder="搜索 商品"
            v-model="keytitle"
            @keyup.enter="onSearch(keytitle)"
          />
          <div class="search_right" @click="onSearch(keytitle)"></div>
        <!-- </div> -->
        <!-- <div class="search_hot">
          <a>热搜：</a>
          <a href="javascript:void(0)" @click="onGoodsDetail(67846,174941, '为你推荐')">即食燕窝</a>
          <a href="javascript:void(0)" @click="onGoodsDetail(67806,174925, '为你推荐')">鲜炖燕窝</a>
          <a href="javascript:void(0)" @click="onGoodsDetail(45326,130317, '为你推荐')">一次性口罩</a>
          <a href="javascript:void(0)" @click="onGoodsDetail(19081,45451, '为你推荐')" class="before">晶珠藏酒</a>
        </div> -->
      </div>
      <div class="qr_code">
        <!-- <button class="btn_1" @click="goCar">
          <i class="el-icon-my-export"></i>
          购物车
        </button> -->
        <!-- <button class="btn_2" @click="goOrder">我的订单</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "../bus.js";
// import { memberInfo } from "@/api/memberCenter";
export default {
  name: "sjphead",
  data() {
    return {
      icon: "", //头像
      nick: "", //昵称
      phone: "", //手机号码
      keytitle: "", // 搜索内容
      telephone: "",
      authCode: "",
      sortCode: "", // 纠正密码
      errtels: 0, // 手机号错误框
      errcode: 0, // 验证码错误框
      codeTitle: "获取验证码",
      second: 29, // 倒计时
      message: "", // 错误提示文字
      errMes: 0, // 错误显示
      agree: 1, // 默认协议
      headerFix: true
    };
  },
  created() {
    // localStorage.getItem("userToken") ? this.getUser() : "";
    // this.isLogin();
    console.log("**********header**********");
    console.log(localStorage.getItem("userInfo"))
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    console.log("**********header000000**********")
    console.log(userInfo)
    this.icon = userInfo.icon
    this.nick = userInfo.nick
    this.phone = userInfo.phone
  },
  methods: {
    // 登陆注册/显示
    loginToast() {
      this.$router.push({
        path: "/logreg"
      });
    },
    toGsjp() {
    this.$router.push({
      path: "/indexGsjp"
    });
    },
    toMqjp() {
    this.$router.push({
      path: "/indexMqjp"
    });
    },
    // 搜索
    onSearch(title) {
      console.log(title);
      this.$router.push({
        path: "/search",
        query: {
          key: title,
          t: +new Date()
        }
      });
    },
    // async getUser() {
    //   let _this = this;
    //   console.log(localStorage.getItem('userInfo'))
    //   let userInfo = localStorage.getItem('userInfo')
    //   if (!userInfo) {
    //     const res = await memberInfo();
    //     console.log(res);
    //     if (res.code == 200) {
    //       _this.icon = res.data.icon;
    //       _this.nick = res.data.nickname;
    //       _this.phone = res.data.phone;
    //       let logout = {
    //         icon: resMember.data.icon,
    //         nick: resMember.data.nickname,
    //         phone: resMember.data.phone
    //       };
    //       localStorage.setItem("userInfo", JSON.stringify(logout));
    //       // bus中间件
    //       // let userInfo = {
    //       //   icon: res.data.icon,
    //       //   nick: res.data.nickname,
    //       //   phone: res.data.phone
    //       // };
    //       // this.$nextTick(function() {
    //       //   Bus.$emit("userInfo", userInfo);
    //       // });
    //       // localStorage.setItem("icon", res.data.icon);
    //       // localStorage.setItem("nick", res.data.nickname);
    //       // localStorage.setItem("phone", res.data.phone);
    //       // localStorage.setItem("carnum", res.data.cartItemNum);
    //     }
    //   }else{
    //     _this.icon = _this.$store.state.user.icon;
    //     _this.nick = _this.$store.state.user.nickname;
    //     _this.phone = _this.$store.state.user.phone;        
    //   }
    // },
    // 退出
    signOut() {
      localStorage.removeItem("userToken");
      // localStorage.removeItem("carNum");
      // localStorage.removeItem("icon");
      // localStorage.removeItem("nick");
      // localStorage.removeItem("phone");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("carnum");
      this.$router.push({
        path: "/logreg"
      });
    },
    // 个人中心
    onUser() {
      this.$router.push({
        path: "/home",
        query: {
          key: 0
        }
      });
    },
    // 我的订单
    goOrder() {
      this.$router.push({
        path: "/orderList",
        query: {
          key: 2
        }
      });
    },
    // 跳转购物车
    goCar() {
      this.$layer.msg('加入购物车')
      // this.$router.push({
      //   path: "/car"
      // });
    },
    // 客服
    customer() {},
    // 商品详情
    onGoodsDetail(id, proId, title) {
      console.log(id, proId, title);
      let router = this.$router.resolve({
        path: "/goodsDetail",
        query: {
          id: id
        }
      });
      window.open(router.href, "_blank");
      let classId = proId + "";
      console.log(classId);
      localStorage.setItem("className", title);
      localStorage.setItem("classId", classId.substring(0, 2));
    }
  },
  beforeCreate() {
    let _this = this;
    // Bus.$on("getUser", function(val) {
    //   console.log(val);
    //   _this.getUser();
    // });
  },
  mounted() {
    let _this = this;
    // Bus.$on('userInfo', function(user) {
    //   console.log(user)
    //   _this.icon = user.icon
    //   _this.nick = user.nick
    //   _this.phone = user.phone
    // })
    Bus.$on("loginToast", function() {
      _this.loginToast();
    });
    // Bus.$on("getUser", function(val) {
    //   console.log(val);
    //   _this.getUser();
    // });
    Bus.$on("goOrder", function() {
      _this.goOrder();
    });
    Bus.$on("goCar", function() {
      _this.goCar();
    });
    // Bus.$on("loginShow", function(val) {
    //   console.log(val);
    //   _this.loginShow = val;
    // });
    $(window).scroll(function() {
      // console.log($(document).scrollTop());
      if ($(document).scrollTop() > 250) {
        _this.headerFix = false;
      } else {
        _this.headerFix = true;
      }
    });
    $("#header .yu_boxs .tels .right").on("click", function() {
      $(this).hide();
    });
    $("#header .yu_boxs .tels input").focus(function() {
      $("#header .yu_boxs .tels .right").show();
    });
    $("#header .yu_boxs .agree .left").on("click", function() {
      $(this).hasClass("active")
        ? $(this).removeClass("active")
        : $(this).addClass("active");
    });
  },
  watch: {
    $route(to, from) {
      console.log("**********header**********");
      if (to.name != "search" && from.name == "search") {
        this.keytitle = "";
      }
      // localStorage.getItem("userToken") ? this.getUser() : "";
    }
  }
};
</script>

<style lang="less" scoped>
#header {
  background-color: rgba(255, 255, 255, 1);
  width: 1301px;
  height: 148px;
  margin: 0 auto;
}
.header_fix {
  height: 0;
  background: #fff;
  font-size: 0;
  text-align: center;
  transition: 0.1s;
  -moz-transition: 0.1s;
  -webkit-transition: 0.1s;
  -o-transition: 0.1s;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  &.active {
    height: 60px;
    padding: 10px 0;
  }
  .logo {
    display: inline-block;
    vertical-align: top;
    height: 40px;
    img {
      height: 40px;
    }
  }
  .search {
    display: inline-block;
    vertical-align: top;
    height: 36px;
    border: 1px solid rgba(180, 160, 120, 1);
    border-radius: 18px;
    margin: 2px 60px 0;
    overflow: hidden;
    position: relative;
    &::before {
      content: "";
      width: 18px;
      height: 18px;
      // background: url("../assets/images/icon_0.png") 0 0 no-repeat;
      position: absolute;
      top: 10px;
      left: 18px;
    }
    .search_left {
      float: left;
      width: 500px;
      height: 30px;
      line-height: 36px;
      padding-left: 46px;
      background: #FFFFFF;
      border: 1px solid #F4162A;
      &::-webkit-input-placeholder {
        color: #999;
      }
      &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #999;
      }
      &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #999;
      }
      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #999;
      }
    }
    .search_right {
      float: left;
      width: 36px;
      height: 30px;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      background: #F4162A;
    }
  }
  .car {
    display: inline-block;
    vertical-align: top;
    width: 40px;
    height: 40px;
    border: 1px solid #b4a078;
    border-radius: 50%;
    padding: 10px;
    i {
      float: left;
      width: 18px;
      height: 18px;
      background: url(../assets/images/icon_0.png) -18px 0 no-repeat;
    }
  }
}
.header_top {
    width: 1301px;
  height: 40px;
  background: #F5F5F5;
  .container {
    a {
      float: right;
      color: rgb(0, 0, 0);
      line-height: 40px;
      margin: 0 14px;
      position: relative;
      &::before {
        content: "";
        width: 1px;
        height: 18px;
        background: rgb(0, 0, 0);
        overflow: hidden;
        position: absolute;
        top: 12px;
        left: -14px;
      }
      &.before::before {
        opacity: 0;
      }
      &.right {
        float: right;
      }
    }
    dl {
      float: right;
      height: 40px;
      padding: 14px 14px 0;
      position: relative;
      dt {
        float: left;
        width: 100%;
        color: rgb(0, 0, 0);
        cursor: pointer;
        i {
          float: right;
          width: 13px;
          height: 8px;
          margin: 3px 0 0 8px;
          background-image: url("../assets/images/icon_0.png");
          background-repeat: no-repeat;
          background-position: -174px 0;
        }
      }
      dd {
        display: none;
        width: 210px;
        // text-align: center;
        padding: 10px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 5px 0px rgba(153, 153, 153, 0.1);
        position: absolute;
        top: 40px;
        right: -80px;
        z-index: 99;
        i {
          width: 17px;
          height: 10px;
          background: url("../assets/images/icon_0.png") -79px -122px no-repeat;
          position: absolute;
          top: -7px;
          left: 90px;
        }
        img {
          float: left;
          width: 56px;
          height: 56px;
          border-radius: 50%;
        }
        p {
          float: left;
          width: 134px;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
          padding: 0 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        a {
          float: left;
          color: #999;
          font-size: 12px;
          font-weight: bold;
          line-height: 24px;
          padding: 0 10px;
          margin: 0;
        }
      }
      &:hover dd {
        display: block;
      }
    }
  }
}
.header_bottom {
  display: flex;
  justify-content: flex-center;
  position: relative;
 // width: 1920px;
  width: 1301px;
  height: 100px;
  background: #FFFFFF;
  padding: 0px 0 10px;
  .logo {
    float: left;
    font-size: 0;
    line-height: 0;
    padding-top: 18px;
    //padding-left: 310px;
    width: 180px;
      height: 55px;
    // img {
    //   width: 180px;
    //   height: 55px;
    // }
  }
  .txt1 {
    width: 98px;
    height: 33px;
    //margin-left: 580px;
    margin-left: 90px;
    padding-top: 34px;
    font-size: 24px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
  }
  .txt2 {
    width: 98px;
    height: 33px;
    //margin-left: 740px;
    margin-left: 60px;
    padding-top: 34px;
    font-size: 24px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
  }
      .search_box {
            //margin-left: 1080px;
            margin-left: 240px;
            padding-top: 36px;
      width: 336px;
      height: 30px;
      border-radius: 21px;
      //margin-top: 30px;
      //margin-right: 100px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 12px;
        left: 18px;
      }
      .search_left {
        float: left;
        //width: 450px;
        width: 300px;
        height: 30px;
        line-height: 36px;
        padding-left: 10px;
        background: #FFFFFF;
        border: 1px solid #F4162A;
        &::-webkit-input-placeholder {
          color: #999;
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999;
        }
        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999;
        }
        &:-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #999;
        }
      }
      .search_right {
          float: left;
          width: 36px;
          height: 30px;
          font-size: 16px;
          color: rgba(255, 255, 255, 1);
          line-height: 36px;
          text-align: center;
          cursor: pointer;
          background: url("../assets/images/icon_00.png") 0 0 no-repeat;
          border: 1px solid #F4162A;
      }
    }
    .search_hot {
      width: 336px;
      padding-top: 1px;
      overflow: hidden;
      a {
        float: left;
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin: 0 3px;
        position: relative;
        &.before::before {
          opacity: 0;
        }
      }
    }
  .search {
    width: 340px;
    height: 30px; 
    margin-left: 1080px;
    // .search_box {
    //   width: 336px;
    //   height: 30px;
    //   border-radius: 21px;
    //   //margin-top: 30px;
    //   //margin-right: 100px;
    //   position: relative;
    //   &::before {
    //     content: "";
    //     position: absolute;
    //     top: 12px;
    //     left: 18px;
    //   }
    //   .search_left {
    //     float: left;
    //     //width: 450px;
    //     width: 300px;
    //     height: 30px;
    //     line-height: 36px;
    //     //padding-left: 10px;
    //     background: #FFFFFF;
    //     border: 1px solid #F4162A;
    //     &::-webkit-input-placeholder {
    //       color: #999;
    //     }
    //     &::-moz-placeholder {
    //       /* Mozilla Firefox 19+ */
    //       color: #999;
    //     }
    //     &:-moz-placeholder {
    //       /* Mozilla Firefox 4 to 18 */
    //       color: #999;
    //     }
    //     &:-ms-input-placeholder {
    //       /* Internet Explorer 10-11 */
    //       color: #999;
    //     }
    //   }
    //   .search_right {
    //       float: left;
    //       width: 36px;
    //       height: 30px;
    //       font-size: 16px;
    //       color: rgba(255, 255, 255, 1);
    //       line-height: 36px;
    //       text-align: center;
    //       cursor: pointer;
    //       background: url("../assets/images/icon_00.png") 0 0 no-repeat;
    //       border: 1px solid #F4162A;
    //   }
    // }
    // .search_hot {
    //   width: 36px;
    //   padding-top: 1px;
    //   overflow: hidden;
    //   a {
    //     float: left;
    //     font-size: 12px;
    //     font-weight: 400;
    //     color: rgba(153, 153, 153, 1);
    //     margin: 0 3px;
    //     position: relative;
    //     &.before::before {
    //       opacity: 0;
    //     }
    //   }
    // }
  }
  .qr_code {
    float: right;
    margin-top: 35px;
    margin-left: 50px;
    font-size: 24px;
    .btn_1 {
      width: 94px;
      height: 30px;
      background: #F4162A;
      border: 1px solid #F4162A;
      font-size: 16px;
      font-family: STHeitiSC-Medium, STHeitiSC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 16px;
      .el-icon-my-export{
        background: url(../assets/images/icon_01.png) center no-repeat;
        background-size: cover;
      }
      .el-icon-my-export:before{
        content: "\e611";
      }
    }
    .btn_2 {
      width: 104px;
      height: 30px;
      background: #F4F4F4;
      border: 1px solid #E8E8E8;
      font-size: 16px;
      font-family: STHeitiSC-Medium, STHeitiSC;
      font-weight: 500;
      color: #000000;
      line-height: 16px;
    }
  }
}
.yu_mask {
  .yu_boxs {
    width: 356px;
    height: 334px;
    margin: 0 auto;
    padding: 0 40px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin-top: -167px;
    z-index: 245;
    h3 {
      color: #333;
      font-size: 18px;
      text-align: center;
      padding: 27px 0;
    }
    .label {
      width: 100%;
      height: 38px;
      margin-bottom: 14px;
      border: 1px solid rgba(218, 218, 218, 1);
      border-radius: 2px;
      position: relative;
      overflow: hidden;
      &.active {
        border-color: #d4282d;
      }
      .left,
      .right {
        background-image: url("../assets/images/icon_0.png");
        background-repeat: no-repeat;
      }
      .left {
        float: left;
        width: 12px;
        height: 18px;
        margin: 10px;
        background-position: -38px -122px;
        position: relative;
        &::before {
          content: "";
          width: 1px;
          height: 22px;
          background: #dadada;
          overflow: hidden;
          position: absolute;
          top: -2px;
          right: -10px;
        }
      }
      .right {
        float: right;
        width: 16px;
        height: 16px;
        margin: 10px 12px;
        background-position: -50px -122px;
        cursor: pointer;
        display: none;
      }
      &.code input {
        width: 186px;
      }
      input {
        float: left;
        color: #333;
        width: 202px;
        height: 36px;
        line-height: 36px;
        padding-left: 8px;
        border: none;
      }
      span {
        float: right;
        color: #333;
        width: 88px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #eee;
        cursor: pointer;
      }
    }
    .errmes {
      color: #d4282d;
      font-size: 12px;
      line-height: 13px;
      margin-top: -7px;
      overflow: hidden;
      i {
        float: left;
        width: 13px;
        height: 13px;
        margin-right: 5px;
        background-image: url("../assets/images/icon_0.png");
        background-repeat: no-repeat;
        background-position: -66px -122px;
      }
    }
    .agree {
      width: 100%;
      overflow: hidden;
      .left {
        float: left;
        width: 19px;
        height: 19px;
        margin-right: 5px;
        cursor: pointer;
        background-image: url("../assets/images/icon_0.png");
        background-position: 0 -122px;
        &.active {
          background-position: -19px -122px;
        }
      }
      .right {
        float: left;
        color: #999;
        font-size: 12px;
        line-height: 19px;
        a {
          color: #333;
          font-size: 12px;
          line-height: 19px;
          display: inline-block;
          vertical-align: top;
        }
      }
    }
    .login {
      float: left;
      width: 100%;
      height: 48px;
      color: #fff;
      font-size: 20px;
      text-align: center;
      line-height: 48px;
      margin: 26px auto 12px;
      background: #b4a078;
    }
  }
}
</style>